import React          from 'react';
import RadioComponent from './RadioComponent';

const Panelized = (props) => {
  const name = 'is_panelized';
  const {parameters} = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="panelized">
      <span>
        Are your Gerbers already step and repeated (panelized)?
      </span>
      <div className="row">
        <div className="col-6">
          <RadioComponent
            name={name}
            label="Yes"
            value="1"
            checked={parameters[name] === '1'}
            onChange={props.onChange || onChange}
            inputId="panelized-yes"
            groupName={props.groupName} />
        </div>
        <div className="col-6">
          <RadioComponent
            name={name}
            label="No"
            value="0"
            checked={parameters[name] === '0'}
            onChange={props.onChange || onChange}
            inputId="panelized-no"
            groupName={props.groupName} />
        </div>
      </div>
      <div id="error_is_panelized" />
    </div>
  );
};

export default Panelized;
